module.exports = __webpack_public_path__ + "static/media/icn_ui_arrow_small_down.70e43084.svg";